<template>
  <!-- <main class="main maintenance" role="main"> -->
  <main class="customer_intro">
    <div class="intro_inner_wrap" v-if="step_1">
      <div class="intro_inner">
        <div class="text_area">
          <h1>퍼스에 오신 것을<br />환영해요!</h1>
        </div>
        <div class="img_area">
          <Lottie :options="animationOptions[0]" />
        </div>
      </div>
      <div class="intro_btn_area" @click="intro_step(2)">
        <button>다음</button>
      </div>
    </div>

    <div class="intro_inner_wrap" v-show="step_2">
      <div class="intro_inner">
        <div class="text_area">
          <h1>내게 맞는 통신 상품을<br />부담없이 알아보고!</h1>
        </div>
        <div class="img_area">
          <Lottie :options="animationOptions[1]" />
        </div>
      </div>
      <div class="intro_btn_area" @click="intro_step(3)">
        <button>다음</button>
      </div>
    </div>

    <div class="intro_inner_wrap" v-show="step_3">
      <div class="intro_inner">
        <div class="text_area">
          <h1>견적 제안받아,<br />한눈에 비교하고</h1>
        </div>
        <div class="img_area">
          <Lottie :options="animationOptions[2]" />
        </div>
      </div>
      <div class="intro_btn_area" @click="intro_step(4)">
        <button>다음</button>
      </div>
    </div>

    <div class="intro_inner_wrap" v-show="step_4">
      <div class="intro_inner">
        <div class="text_area">
          <h1>퍼스지급보장으로<br />걱정 없이 안전거래!</h1>
        </div>
        <div class="img_area">
          <Lottie :options="animationOptions[3]" />
        </div>
      </div>
      <div class="intro_btn_area" @click="intro_step(5)">
        <button>다음</button>
      </div>
    </div>

    <div class="intro_inner_wrap" v-show="step_5">
      <div class="intro_inner">
        <div class="text_area">
          <h1>합리적인 요금,<br />최대 혜택을 누려보세요!</h1>
        </div>
        <div class="img_area">
          <Lottie :options="animationOptions[4]" />
        </div>
      </div>
      <div class="intro_btn_area" @click="goLoginPage()">
        <button class="btn_start">시작하기 ></button>
      </div>
    </div>
  </main>
</template>

<script>
import Lottie from 'vue-lottie/src/lottie';

export default {
  name: '',
  components: {
    Lottie,
  },
  data() {
    return {
      animationOptions: [
        {
          animationData: require('@/assets/front/animation/ani_intro_01.json'),
        },
        {
          animationData: require('@/assets/front/animation/ani_intro_02.json'),
        },
        {
          animationData: require('@/assets/front/animation/ani_intro_03.json'),
        },
        {
          animationData: require('@/assets/front/animation/ani_intro_04.json'),
        },
        {
          animationData: require('@/assets/front/animation/ani_intro_05.json'),
        },
      ],
      step_1: true,
      step_2: false,
      step_3: false,
      step_4: false,
      step_5: false,
    };
  },
  created() {},
  async mounted() {},
  computed: {},
  methods: {
    intro_step(next) {
      if (next == 2) {
        this.step_1 = false;
        this.step_2 = true;
        this.step_3 = false;
        this.step_4 = false;
        this.step_5 = false;
      } else if (next == 3) {
        this.step_1 = false;
        this.step_2 = false;
        this.step_3 = true;
        this.step_4 = false;
        this.step_5 = false;
      } else if (next == 4) {
        this.step_1 = false;
        this.step_2 = false;
        this.step_3 = false;
        this.step_4 = true;
        this.step_5 = false;
      } else if (next == 5) {
        this.step_1 = false;
        this.step_2 = false;
        this.step_3 = false;
        this.step_4 = false;
        this.step_5 = true;
      }
    },
    goLoginPage() {
      localStorage.setItem('customer_intro_view', 'true');
      this.$router.replace({ name: 'Auth.Login' });
    },
  },
};
</script>

<style></style>
